import {
  LOGIN, ERROR, USER_LIST, LOGOUT, FLUSH, UPDATE_USER, MESSAGE, 
  USER_DETAILS, USER_TYPES, USER_REVIEWS, USER_FRIENDS, SHARE_PROFILE_USER_DETAILS,
  SHARE_PROPERTY_DETAILS, SHARE_POST_DETAILS, TERM_CONDITIONS, PRIVACY_POLICY, TOTAL_USER
} from './constants';
import { SERVER_ADDR, SLEEP_TIME, JWT_TOKEN } from '../../../constants';

export const login = formData => async (dispatch, getState, api) => {
  try {
    const data = { email: formData.email, password: formData.password };

    const res = await api
      .post(`${SERVER_ADDR}login`, { data });
    
    if (res.code === 200) {
      localStorage.setItem(JWT_TOKEN, res.body.token);

      dispatch({
        type: LOGIN,
        firstName: res.body.firstName,
        lastName: res.body.lastName,
        roleId: res.body.roleId,
        isAdmin: res.body.isAdmin,
        email: formData.email
      });

      return res.body;
    } else {
      throw new Error(res.message);
    }
  } catch (e) {
    console.log(e);
    dispatch({
      type: ERROR,
      error: e.message || 'Error while Sign-In. Please try again'
    });
  }
};

export const logout = () => async (dispatch) => {
  try {
    localStorage.removeItem('jwtToken');
    dispatch({
      type: LOGOUT
    });

    dispatch({
      type: FLUSH
    });
  } catch (e) {
    console.log(e);

    dispatch({
      type: ERROR,
      error: e.message,
    });
  }
}

export const getList = (page, rowsPerPage, roleId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}users?roleId=${roleId}&page=${page}&offset=${rowsPerPage}`);

    console.log('res', res);
    if (res.code === 200) { 
      dispatch({
        type: USER_LIST,
        result: res.body.row
      });
      dispatch({
        type: TOTAL_USER,
        result: res.body.count
      });
    } else {
      throw new Error('Something went wrong');
    }
  } catch (e) {
    dispatch({
      type: ERROR,
      error: e.message,
    });
  }
}

export const getUserDetail = (userId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}user/${userId}`);

    if (res.body.user) {
      res.body.roleId = res.body.user.roleId;
      res.body.email = res.body.user.email;
      delete res.body.user;
    }

    dispatch({
      type: USER_DETAILS,
      result: res.body
    });

  } catch (e) {
    console.log(e);

    dispatch({
      type: ERROR,
      error: e.message,
    });
  }
}

export const updateUser = (userId, formData) => async (dispatch, getState, api) => {
  try {
    if (formData.profilePic) {
      formData.image = formData.profilePic[0].name;
      delete formData.profilePic;
    }

    const res = await api
      .post(`${SERVER_ADDR}user/${userId}`, {data: formData})

    dispatch({
      type: USER_DETAILS,
      result: formData
    });

    dispatch({
      type: MESSAGE,
      message: 'User Updated'
    });

    dispatch(resetMessage());
  } catch (e) {
    console.log(e);

    dispatch({
      type: ERROR,
      error: e.message,
    });
  }
}

export const resetMessage = () => (dispatch) => {
  setTimeout(() => {
    dispatch({
      type: MESSAGE,
      message: null
    })
  }, SLEEP_TIME);
}

export const deleteUserImage = (userId) => async (dispatch, getState, api) => {
  const getUserDetails = getState().user.details;
  delete getUserDetails.image;

  try {
    const res = await api
      .del(`${SERVER_ADDR}user/image/${userId}`);

    dispatch({
      type: USER_DETAILS,
      result: getUserDetails
    });
  } catch (e) {
    console.log(e);
  }
}

export const getUserTypes = () =>  async (dispatch, getState, api) => {
  try {
    const res = await api
      .get(`${SERVER_ADDR}user/types`);

    dispatch({
      type: USER_TYPES,
      result: res.body
    });
  } catch (e) {
    console.log(e);
  }
}

export const deleteUser = (userId) => async (dispatch, getState, api) => {
  try {
    const res = await api
      .del(`${SERVER_ADDR}user/${userId}`);

    dispatch(getList());
  } catch (e) {
    console.log(e);
  }
}

export const getUserReviews = (userId) => async (dispatch, getState, api) => {
  try {
    const res = await api
    .get(`${SERVER_ADDR}user/${userId}/reviews`);
    console.log('res',res);

    dispatch({
      type: USER_REVIEWS,
      result: res.body
    });
  } catch (e) {
    console.log(e);
  }
}

export const getUserFriends = (userId, page, offset) => async (dispatch, getState, api) => {
  try {
    const res = await api
    .get(`${SERVER_ADDR}user/${userId}/friends?page=${page}&offset=${offset}`);

    console.log('res',res);

    dispatch({
      type: USER_FRIENDS,
      result: res.body
    });
  } catch (e) {
    console.log(e);
  }
}


export const updateUserPassword = (formData, userId) => async (dispatch, getState, api) => {
  try {
    const data = {
      password: formData.password,
      id: userId
    };

    const res = await api
      .put(`${SERVER_ADDR}forgotPassword`, { data });

    if (res.code === 200) {
      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export const updateTravelGUserPassword = (formData, userId) => async (dispatch, getState, api) => {
  try {
    const data = {
      password: formData.password,
      id: userId
    };

    const res = await api
      .put(`http://100.25.94.111:3357/api/forgotPassword`, { data });

    if (res.code === 200) {
      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export const recommendUser = (formData, userId) => async (dispatch, getState, api) => {
  try {
    const data = {
      email: formData.email,
      comment: formData.message,
      userId: userId,
      recommBy: 0,
      name: formData.name,
      otp: formData.otp,
      phone: formData.phoneNumber
    };

    const res = await api
      .post(`${SERVER_ADDR}recommendUser?email=1`, { data });

    if (res.code === 200) {
      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export const getSharedProfile = (userId) => async (dispatch, getState, api) =>{
  try {
    const res = await api
    .get(`${SERVER_ADDR}shareProfile/${userId}`);

    if (res.code === 200) {
      dispatch({
        type: SHARE_PROFILE_USER_DETAILS,
        result: res.body
      });

      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const getVacancyShareDetails = (propertyId) => async (dispatch, getState, api) =>{
  try {
    const res = await api
    .get(`${SERVER_ADDR}apiShareVacancy/${propertyId}`);

    if (res.code === 200) {
      dispatch({
        type: SHARE_PROPERTY_DETAILS,
        result: res.body
      });

      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const getPostShareDetails = (postId) => async (dispatch, getState, api) =>{
  try {
    const res = await api
    .get(`${SERVER_ADDR}apiSharePost/${postId}`);

    if (res.code === 200) {
      dispatch({
        type: SHARE_POST_DETAILS,
        result: res.body
      });

      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const getPrivacyPolicy = () => async (dispatch, getState, api) =>{
  try {
    const res = await api
    .get(`${SERVER_ADDR}privacyPolicy`);

    if (res.code === 200) {
      dispatch({
        type: PRIVACY_POLICY,
        result: res.body
      });

      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const getTermsAndConditions = () => async (dispatch, getState, api) =>{
  try {
    const res = await api
    .get(`${SERVER_ADDR}termsConditions`);

    if (res.code === 200) {
      dispatch({
        type: TERM_CONDITIONS,
        result: res.body
      });

      return;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const getUserName = (userId) => async (dispatch, getState, api) =>{
  try {
    const res = await api
      .get(`${SERVER_ADDR}getUserName/${userId}`);

    if (res.code === 200) {
      return res.body;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}

export const sendOtp = (email, phone) => async (dispatch, getState, api) =>{
  try {
    const res = await api
      .post(`${SERVER_ADDR}sendOtpVisitor`, { data: { email, phone } });

    if (res.code === 200) {
      return res.body;
    }

    throw new Error(res.message);
  } catch (e) {
    console.log(e);
  }
}